import { useRouteMatch } from 'react-router-dom';
import routes from '@config/routes';

import mentionsPost, { getList as getPost } from '@stores/mentionsOfficialAccountPost';
import mentionsComment, { getList as getComment } from '@stores/mentionsOfficialAccountComment';
import { getUnread } from '@stores/mentionsOfficialAccountUnread';
import { useEffect } from 'react';

interface MentionsFilters {
  list: any;
  getList: any;
}

const useMentionsOfficialAccountFilters = (): MentionsFilters => {
  useEffect(() => {
    getUnread();
  }, []);

  const isComments = useRouteMatch({
    path: routes.mentionsOfficialAccountComment.path,
  });

  if (isComments) return { list: mentionsComment, getList: getComment };

  return { list: mentionsPost, getList: getPost };
};

export default useMentionsOfficialAccountFilters;
